$(document).ready(function() {

  $('.modal-slider-section .project-gallery li').on('click', function() {
    var clicked = $(this);
    var clickedClass= $(this).attr('class');
    console.log(clickedClass);
    $('.modal-slider-overlay').addClass('show');
    $('.modal-slider .slick-slide').removeClass('slick-active slick-current forward');

   $('.modal-slider .slick-slide').each(function() {
                var crrnt = $(this);

                if (crrnt.hasClass(clickedClass)) {
                    crrnt.addClass('slick-active slick-current forward');
                }

                else {
                    crrnt.removeClass('slick-active slick-current forward');
                }
            });	
	
  });

 


  
  $('.modal-slider-section .modal-slider-overlay .slider-close').on('click', function() {
    $('.modal-slider-overlay').removeClass('show');
  });


});

/*

function FadeInSection(props) {
  const [isVisible, setVisible] = React.useState(true);
  const domRef = React.useRef();
  React.useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => setVisible(entry.isIntersecting));
    });
    observer.observe(domRef.current);
    return () => observer.unobserve(domRef.current);
  }, []);
  return (
    <div
      className={`fade-in-section ${isVisible ? 'is-visible' : ''}`}
      ref={domRef}
    >
      {props.children}
    </div>
  );
}
*/



